import { ReactNode } from 'react';

import Box from '@mui/material/Box';

import styles from './styles.module.scss';

export function AutocompleteOption({
  optionProps,
  title,
  description,
  label,
  icon,
}: {
  optionProps: any;
  title: ReactNode;
  description?: React.ReactNode;
  label?: React.ReactNode;
  icon?: React.ReactNode;
}) {
  const { key, ...optionPropsWithoutKey } = optionProps;
  return (
    <Box component={'div'} {...optionPropsWithoutKey}>
      <div className={styles.autocompleteOptionIcon}>{icon}</div>
      <div className={styles.autocompleteOptionTitleDescription}>
        <span className={styles.autocompleteOptionTitle}>{title}</span>
        {description ? (
          <>
            &nbsp;<span className={styles.autocompleteOptionDescription}>({description})</span>
          </>
        ) : null}
      </div>
      {label ? <div className={styles.autocompleteOptionLabel}>{label}</div> : null}
    </Box>
  );
}
